"use client";
import { jsx as s } from "react/jsx-runtime";
import { css as m } from "@emotion/react";
import c from "@emotion/styled";
import { forwardRef as d } from "react";
const i = d(
  ({ alt: t = "", ...o }, e) => /* @__PURE__ */ s(f, { ...o, alt: t, "data-comp": "image", ref: e })
);
i.displayName = "Image";
const l = i, f = c.img(
  ({ feStretch: t, feHeight: o, feWidth: e, feObjectFit: a, feObjectPosition: r }) => m`
		height: ${o};
		object-fit: ${a};
		object-position: ${r};
		width: ${e};

		${t && m`
			height: 100%;
			width: 100%;
		`}
	`
);
export {
  l as default
};
